import { createTheme } from "@mantine/core";
import { themeComponents } from "./components";
import { accentColors, brandColors, mossColors, sandColors, slateColors } from "./colors";
import { bodyFontFamily, headingFontFamily } from "./typography";

export const theme = createTheme({
    primaryColor: "brand",
    primaryShade: {
        light: 7,
        dark: 4,
    },
    autoContrast: true,
    colors: {
        accent: accentColors,
        brand: brandColors,
        moss: mossColors,
        sand: sandColors,
        slate: slateColors,
    },
    black: "#11212f",
    white: "#ffffff",
    fontFamily: bodyFontFamily,
    fontFamilyMonospace: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace',
    headings: {
        fontFamily: headingFontFamily,
        fontWeight: "700",
        textWrap: "balance",
        sizes: {
            h1: { fontSize: "clamp(2rem, 5vw, 3.5rem)", lineHeight: "1.05" },
            h2: { fontSize: "clamp(1.75rem, 4vw, 2.75rem)", lineHeight: "1.1" },
            h3: { fontSize: "clamp(1.4rem, 3vw, 2rem)", lineHeight: "1.15" },
            h4: { fontSize: "1.25rem", lineHeight: "1.2" },
            h5: { fontSize: "1.05rem", lineHeight: "1.25" },
            h6: { fontSize: "0.95rem", lineHeight: "1.3" },
        },
    },
    defaultRadius: "xs",
    radius: {
        xs: "0.075rem",
        sm: "0.15rem",
        md: "0.25rem",
        lg: "0.35rem",
        xl: "0.45rem",
    },
    spacing: {
        xs: "0.5rem",
        sm: "0.75rem",
        md: "1rem",
        lg: "1.5rem",
        xl: "2rem",
    },
    fontSizes: {
        xs: "0.75rem",
        sm: "0.875rem",
        md: "1rem",
        lg: "1.125rem",
        xl: "1.25rem",
    },
    lineHeights: {
        xs: "1.3",
        sm: "1.4",
        md: "1.55",
        lg: "1.65",
        xl: "1.8",
    },
    breakpoints: {
        xs: "36em", // 576px
        sm: "48em", // 768px
        md: "62em", // 992px
        lg: "75em", // 1200px
        xl: "88em", // 1408px
    },
    shadows: {
        xs: "0 1px 2px rgba(17, 33, 47, 0.06)",
        sm: "0 8px 24px rgba(17, 33, 47, 0.08)",
        md: "0 14px 36px rgba(17, 33, 47, 0.12)",
        lg: "0 22px 48px rgba(17, 33, 47, 0.16)",
        xl: "0 32px 72px rgba(17, 33, 47, 0.2)",
    },
    cursorType: "pointer",
    components: themeComponents,
    other: {
        appShell: {
            headerHeight: 72,
            toolbarHeight: 60,
        },
        surfaces: {
            light: "#f6fbfc",
            dark: "#13212f",
            elevatedLight: "#ffffff",
            elevatedDark: "#1b2c3c",
        },
    },
});
